import { RouterView } from 'vue-router'

export const hardwareStoreRoutes = [
  {
    name: 'hardwareStore',
    path: '/hardware-store',
    component: RouterView,
    redirect: '/hardware-store',
    meta: {
      locationTypes: ['location', 'singleLocation']
    },
    children: [
      {
        name: 'hardwareStoreHome',
        path: '',
        component: () => import('@/modules/hardware-store/views/HardwareStoreView.vue'),
        meta: {
          locationTypes: ['location', 'singleLocation']
        }
      },
      {
        name: 'hardwareStoreOrders',
        path: 'orders/:id?',
        component: () => import('@/modules/hardware-store/views/HardwareStoreOrdersView.vue'),
        meta: {
          locationTypes: ['location', 'singleLocation']
        }
      },
      {
        name: 'hardwareStoreCheckout',
        path: 'checkout',
        component: () => import('@/modules/hardware-store/views/HardwareStoreCheckoutView.vue'),
        meta: {
          locationTypes: ['location', 'singleLocation']
        }
      }
    ]
  }
]
